import { feedback } from '@ecosystem/newron-design-system';

export const renderLoading = () => {
  return (
    <div data-testid="loading-icon">
      <feedback.DotsLoader />
    </div>
  );
};
